import React, { useState, useEffect } from "react";
import styles from "./home.module.css";
import Header from "../../components/@header/header.js";
import Book from "../book/book.js";
import { getCourses, getLanguagePack } from "../../service/service.js";
import SelectLanguage from "../selectLanguage/selectedLanguage.js";
import { getUser } from "../../service/service";
import Popup from "../popup/popup.js";
import cookie from "react-cookies";

const Home = () => {
  const [courses, setCourses] = useState([]);
  const [coursesLoading, setCoursesLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const currentLanguage = getCurrentLanguage();
  const languagePackage = getLanguagePack();
  const [currentBook, setCurrentBook] = useState(null);
  const [studentName, setStudentName] = useState("Aluno");
  const [popupOpen, setPopupOpen] = useState(false);

  const fetchStudent = async () => {
    // Avoid firing GET /me/ before the OAuth token is available (ARTFRAN-15306).
    if (!cookie.load("token_info")) return;
    try {
      const name = await getUser();
      if (name && name.first_name) setStudentName(name.first_name);
    } catch (_err) {
      // Keep the default greeting on transient auth errors.
    }
  };

  useEffect(() => {
    fetchStudent();
  }, []);

  function getCurrentLanguage() {
    let data = localStorage.getItem("languagePack");
    return data == null ? "en" : JSON.parse(data).selectedLanguage;
  }

  const GREETINGS = {
    pt: "Olá",
    "pt-br": "Olá",
    en: "Hello",
    "en-us": "Hello",
    es: "Hola",
    fr: "Bonjour",
  };

  const FALLBACK_MESSAGES = {
    en: {
      "Estas são as aulas disponíveis para você fazer. Escolha uma para começar!":
        "These are the available classes for you. Choose one to get started!",
      "Carregando cursos...": "Loading courses...",
    },
    es: {
      "Estas são as aulas disponíveis para você fazer. Escolha uma para começar!":
        "Estas son las clases disponibles para ti. ¡Elige una para comenzar!",
      "Carregando cursos...": "Cargando cursos...",
    },
  };

  function getGreeting() {
    const lang = (currentLanguage || "pt").toLowerCase();
    return GREETINGS[lang] || GREETINGS[lang.split("-")[0]] || "Olá";
  }

  function _getMessage(message) {
    const lang = (currentLanguage || "pt").toLowerCase().split("-")[0];
    // Para idiomas não-PT, fallback hardcodado tem prioridade sobre o TaaS
    // (o TaaS pode retornar a chave em PT sem tradução)
    if (
      lang !== "pt" &&
      FALLBACK_MESSAGES[lang] &&
      FALLBACK_MESSAGES[lang][message]
    ) {
      return FALLBACK_MESSAGES[lang][message];
    }
    return languagePackage[message] || message;
  }

  useEffect(() => {
    getCourses({ page: 1, page_size: 50, language: currentLanguage })
      .then((res) => {
        let data = res.data;
        data = res.data.filter(
          (course) =>
            course.book &&
            course.book.language &&
            course.book.language.code === currentLanguage,
        );
        setCourses(data);
      })
      .catch((err) => {
        console.log("error courses: ", err);
      })
      .finally(() => {
        setCoursesLoading(false);
      });
  }, [currentLanguage]);

  // sets currentbook:
  //   if courses list is empty it does nothing
  //   if currentBook exists in localStorage, use it to set currentBook
  //   if it doesn't, set's the first item of Courses as the currentBook
  useEffect(() => {
    if (courses.length !== 0) {
      let currentBookId = localStorage.getItem("currentBookId");
      let book = null;
      if (courses.length > 1) {
        if (currentBookId !== null) {
          currentBookId = parseInt(currentBookId);
          const found = courses.find(
            (course) => course.book && course.book.id === currentBookId,
          );
          book = found ? found.book : courses[0].book;
        } else {
          book = courses[0].book;
        }
      } else {
        book = courses[0].book;
      }
      localStorage.setItem("currentBookId", JSON.stringify(book.id));
      localStorage.setItem("currentBookName", JSON.stringify(book.name));
      setCurrentBook(book);
    }
  }, [courses]);

  function closeModal() {
    setModalOpen(false);
  }

  const changeBook = (e) => {
    const selectedBookId = parseInt(e.target.value);
    const selectedBookObject = courses.find(
      (course) => course.book.id === selectedBookId,
    );
    localStorage.setItem(
      "currentBookId",
      JSON.stringify(selectedBookObject.book.id),
    );
    localStorage.setItem(
      "currentBookName",
      JSON.stringify(selectedBookObject.book.name),
    );
    setCurrentBook(selectedBookObject.book);
    window.location.reload(); // Force reload to update "completed" status on batches after book change
  };

  useEffect(() => {
    const hasLanguagePack = localStorage.getItem("languagePack");

    if (!hasLanguagePack && isWithinValidityPeriod()) {
      setPopupOpen(true);
    }
  }, []);

  const isWithinValidityPeriod = () => {
    const now = new Date();

    const start = new Date(2026, 0, 14); // 14/01/2026
    const end = new Date(2026, 2, 31, 23, 59, 59); // 31/03/2026

    return now >= start && now <= end;
  };

  return (
    <div>
      {modalOpen && <SelectLanguage closeModal={closeModal} />}
      {popupOpen && (
        <Popup popupOpen={popupOpen} onClose={() => setPopupOpen(false)} />
      )}
      <div>
        <Header menuLanguage={true} />
      </div>
      <div className="container-fluid d-flex home-container justify-content-center background-image">
        <div style={{ width: 1200 }}>
          <div>
            <div className={styles.welcome}>
              <h4 title="Aluno">{`${getGreeting()}, ${studentName}`}</h4>
              <p>
                {_getMessage(
                  "Estas são as aulas disponíveis para você fazer. Escolha uma para começar!",
                )}
              </p>
            </div>
          </div>
          <div
            className="card"
            style={{ marginBottom: 50, border: "none", background: "none" }}
          >
            <div>
              {coursesLoading && (
                <div className="loading-lessons-container">
                  <div className="spinner-border home-loading" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div style={{ color: "rgb(117,117,117)" }}>
                    {_getMessage("Carregando cursos...")}
                  </div>
                </div>
              )}
              {courses.length === 0 && !coursesLoading ? (
                <div className="home-no-lessons">No lessons available.</div>
              ) : (
                currentBook && (
                  <div className="all-lessons-container">
                    <Book
                      currentBook={currentBook}
                      courses={courses}
                      changeBook={changeBook}
                      currentLanguage={currentLanguage}
                    />
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
